import { useContext } from 'react';

import { iamConfigName } from '~constants/Constants';
import { VulcanContextProvider } from '~context/VulcanContext';
import { IFormConfig, IIamCommonConfig, ISocialProvider } from '~domain/entities/Config';

export enum IamForms {
    signIn,
    signUp,
    guestCheckout
}

export const useConfig = (formType: IamForms): IFormConfig => {
    const { config = {} } = useContext(VulcanContextProvider);
    const iamConfig = config[iamConfigName];

    return iamConfig[IamForms[formType]];
};

export const useCommonConfig = () => {
    const { config = {} } = useContext(VulcanContextProvider);

    return (config.ramp.common ?? {}) as IIamCommonConfig;
};

export const useSocialIconConfig = (providerName: string): ISocialProvider | undefined => {
    const { config = {} } = useContext(VulcanContextProvider);

    return config[iamConfigName]?.common?.socialProviders?.providers?.find(
        (item: ISocialProvider) => item.providerName === providerName
    );
};
